// removed by extract-text-webpack-plugin
module.exports = {"dialog":"index__dialog--2Jm5Z","dialog--is-open":"index__dialog--is-open--3iMN1"};


//////////////////
// WEBPACK FOOTER
// ./src/client/shared-components/FullScreenDialog/styles/index.scss
// module id = 2k1+
// module chunks = 23